import { render, staticRenderFns } from "./DntSendBlock.vue?vue&type=template&id=13135b1f&scoped=true&"
import script from "./DntSendBlock.vue?vue&type=script&lang=ts&"
export * from "./DntSendBlock.vue?vue&type=script&lang=ts&"
import style0 from "./DntSendBlock.vue?vue&type=style&index=0&id=13135b1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13135b1f",
  null
  
)

export default component.exports